/**
 * Планшет, с которым киоск работает «из коробки».
 *
 * Во Flutter адрес всегда вводил администратор: на первом запуске
 * приложение вело на экран адреса, и до чата доходили только через выбор
 * сервера, планшета и PIN. Для веб-киоска это лишнее — образ собирается
 * под конкретный планшет, и после запуска он должен сразу работать.
 *
 * Поэтому адрес по умолчанию подставляется в хранилище один раз, при самом
 * первом старте (см. `presentation/stores/appBootstrap.ts`). Дальше он
 * живёт как обычный сохранённый адрес: администратор может сменить его с
 * экрана адреса, и подстановка больше не вмешивается. «Полный сброс
 * данных» в журнале разработчика стирает адрес — и на следующем запуске
 * сюда же возвращается умолчание.
 *
 * Значение задаётся при сборке: `VITE_DEFAULT_BASE_URL`. В Docker это
 * аргумент сборки с тем же именем.
 */

import { ServerAddress } from '@/utils/serverAddress';

/**
 * Адрес в том виде, в каком его сохранил бы экран адреса: схема в нижнем
 * регистре, без лишних слешей. Вход по паролю пишет креды как
 * `<root>/<slug>`, и сырой адрес из сборки (`HTTPS://…//slug/`) с ними
 * не совпал бы — киоск спрашивал бы пароль после каждого верного ввода.
 * Пустая строка остаётся пустой: планшета по умолчанию нет.
 */
export function canonicalBaseUrl(raw: string): string {
  if (raw.trim().length === 0) return '';
  return ServerAddress.parse(raw).url;
}

/** Адрес планшета, под который собран образ: `<сервер>/<slug>`. */
export const DEFAULT_BASE_URL: string = canonicalBaseUrl(
  import.meta.env.VITE_DEFAULT_BASE_URL ?? 'https://lp.hron.uz/cic_work_test',
);

/**
 * Подставлять ли адрес по умолчанию вовсе.
 *
 * `VITE_DEFAULT_BASE_URL=""` — сборка без предустановленного планшета:
 * киоск ведёт себя как Flutter-оригинал и спрашивает адрес.
 */
export function hasDefaultBaseUrl(): boolean {
  return DEFAULT_BASE_URL.trim().length > 0;
}
